export const crudStatusEnum = {
    OK: 1,
    INACTIVE: 5,
    DELETED: 10,
};
